import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getIframes = () => {
  return axiosPrivate.get(`/dashboard/api/v1/iframes`);
};
